import { TFunction } from '@lyearn/i18n';
import { BookmarkOutline, Link2Outline } from '@lyearn/icons';

import { onBookmarkClick, onDismissClick, onEmbedClick } from './utils';

export const menuItems = (t: TFunction) => [
  {
    name: 'embed',
    title: t('Lygo:Embed'),
    icon: Link2Outline,
    onItemClick: onEmbedClick,
    isEnabled: () => true,
  },
  {
    name: 'bookmark',
    title: t('Common:ContentCards.Bookmark'),
    icon: BookmarkOutline,
    onItemClick: onBookmarkClick,
    isEnabled: () => true,
  },
  {
    name: 'dismiss',
    title: t('Common:Actions.Dismiss'),
    onItemClick: onDismissClick,
    isEnabled: () => true,
  },
];
